﻿//import { gsap } from 'gsap/all';
//import { Observer } from "gsap/Observer";
//import { ScrollTrigger } from "gsap/ScrollTrigger";
//import { ScrollSmoother } from "gsap/ScrollSmoother";
//import { ScrollToPlugin } from "gsap/ScrollToPlugin";
//import { SplitText } from "gsap/SplitText";

import './homepage.less'

let lastKnownScrollPosition = 0;
let ticking = false;

const manageNavigation = (yPosition) => {
    if (yPosition > 100) {
        document.querySelector(".main-nav").classList.remove("home");
        document.querySelector(".main-nav").classList.add("home-pinned");
    } else {
        document.querySelector(".main-nav").classList.add("home");
        document.querySelector(".main-nav").classList.remove("home-pinned");
    }
}

const init = () => {

    window.addEventListener("scroll", (event) => {
        lastKnownScrollPosition = window.scrollY;

        if (!ticking) {
            // Throttle the event to "do something" every 20ms
            setTimeout(() => {
                manageNavigation(lastKnownScrollPosition);
                ticking = false;
            }, 20);

            ticking = true;
        }
    });


    gsap.registerPlugin( Observer, ScrollTrigger, ScrollSmoother, ScrollToPlugin, SplitText)
    ScrollTrigger.defaults({
        markers: false
    });

    document.fonts.ready.then(() => {
        let slide1 = SplitText.create(".txt_slide_1");
        let slide2 = SplitText.create(".txt_slide_2");  
        let slide3 = SplitText.create(".txt_slide_3");  


        const cursorSize = window.innerWidth > 480 ? "150vw" : "249vw";
        const pin = window.innerWidth > 768 ? "top 70px" : "top 70px";
        const end = window.innerWidth > 768 ? "+=6000" : "+=4000";

        const occasionalAnimation = gsap.timeline({
            scrollTrigger: {
                trigger: "#homeOccasions",
                start: pin,
                end: end,
                pin: true,
                scrub: true,
                invalidateOnRefresh: true,
                markers: false,
            }
        }).to("#homeOccasions .cursor", { duration: 2, width: cursorSize, height: cursorSize, ease: "none" })
            .to("#homeOccasions .cursor", { duration: 2, opacity: 0 }, "<")
            .to("#homeOccasions .media-holder", { duration: 1, opacity: 1 }, "<")
            .to(".full-logo", { duration: 1, opacity: 1 }, "<")
            .to(".txt_slide_base", { duration: 1, opacity: 1 }, "<")
            .from(slide1.chars, { scale: 1.1, duration: 1, autoAlpha: 0, stagger: 0.05 }, "<")
            .to(".slide_1", { duration: 0.5, opacity: 0 }, "+=0.5")
            .from(slide2.chars, { scale: 1.1, duration: 1, autoAlpha: 0, stagger: 0.05 }, "<")
            .to(".slide_2", { duration: 1, opacity: 0 }, "+=0.5")
            .from(slide3.chars, { scale: 1.1, duration: 1, autoAlpha: 0, stagger: 0.05 }, "<")
    })


};

if (document.readyState !== 'loading') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        init();
    });
}